import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {AtendimentoDetalhes} from "../../models/atendimento-detalhes";
import {DetalhesTarefasComponent} from "../detalhes-tarefas/detalhes-tarefas.component";

@Component({
  selector: 'app-atendimento-detalhes',
  standalone: false,
  templateUrl: './atendimento-detalhes.component.html',
  styleUrl: './atendimento-detalhes.component.css'
})
export class AtendimentoDetalhesComponent implements OnInit, OnChanges {
  @Input() atendimentos: AtendimentoDetalhes[] = [];
  @Output() atualizarListaPai = new EventEmitter<void>();

  currentIndex: number = 0;
  atendimento: AtendimentoDetalhes;

  @ViewChild(DetalhesTarefasComponent) detalhesTarefasComponent: DetalhesTarefasComponent;

  showModalDetalhes = false;
  showModalNovoCompromisso = false;

  ngOnChanges(changes: SimpleChanges) {
    if(changes['atendimentos']){
    }
  }


  ngOnInit(): void {
    this.updateCurrentAtendimento();
  }

  public fecharModalDetalhes(): void {
    this.showModalDetalhes = false;
  }

  public buscarDetalheTarefa(id: number){
    this.showModalDetalhes = true;
    this.detalhesTarefasComponent.buscarTarefaPorId(id);
  }

  public abrirNovoCompromisso(): void {
    this.showModalNovoCompromisso = true;
  }

  public fecharNovoCompromisso(): void {
    this.showModalNovoCompromisso = false;
    this.atualizarListaPai.emit();
  }

  updateCurrentAtendimento(): void {
    if (this.atendimentos && this.atendimentos.length > 0) {
      this.atendimento = this.atendimentos[this.currentIndex];
    }
  }

  navigatePrevious(): void {
    if (this.atendimentos && this.atendimentos.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.atendimentos.length) % this.atendimentos.length;
      this.updateCurrentAtendimento();
    }
  }

  navigateNext(): void {
    if (this.atendimentos && this.atendimentos.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.atendimentos.length;
      this.updateCurrentAtendimento();
    }
  }
}
